// For JSLINT
/*global window, document, nexusTracking, o_global, o_util
 */
/*jslint es5: true */

var o_user = o_user || {};

o_user.trackingBuilder = function (document, nexusTracking, ajaxUtil, eventUtil) {
    "use strict";

    function sendTrackingInformation(trackingContainer, trackingType) {
        try {
            if (trackingType === "merge") {
                nexusTracking().submitMerge(trackingContainer);
            } else if (trackingType === "nextPI") {
                nexusTracking().trackOnNextPageImpression(trackingContainer);
            } else {
                nexusTracking().submitEvent(trackingContainer);
            }
        } catch (e) {
            // ignore
        }
    }

    function registerTrackingEventHandler() {
        document.addEventListener("user.sendToTrackingServer", function (event) {
            sendTrackingInformation(event.detail);
        });

        document.addEventListener("user.sendToTrackingServer_merge", function (event) {
            sendTrackingInformation(event.detail, "merge");
        });

        document.addEventListener("user.event.sendToTrackingServer", function (event) {
            sendTrackingInformation(event.detail, "event");
        });
    }

    function init() {
        eventUtil.delegate(document, "click", ".user_js_trackOnClick", function () {
            var element = this,
                trackingLabel = element.getAttribute("data-trackinglabel"),
                trackingValue = element.getAttribute("data-trackingvalue"),
                trackingType = element.getAttribute("data-trackingtype"),
                trackingData = {};

            if (!!trackingLabel) {
                if (!!trackingValue) {
                    trackingData[trackingLabel] = [trackingValue];
                } else if (element.tagName.toLowerCase() === "input" && element.type === "checkbox") {
                    trackingData[trackingLabel] = [element.checked];
                } else {
                    trackingData[trackingLabel] = ["ok"];
                }
                sendTrackingInformation(trackingData, trackingType);
            }
        });

        eventUtil.delegate(document, "click", ".us_js_trackOnNextPageImpression", function () {
            var element = this,
                trackingLabel = element.getAttribute("data-trackinglabel"),
                trackingValue = element.getAttribute("data-trackingvalue"),
                trackingData = {};

            if (!!trackingLabel && !!trackingValue) {
                trackingData[trackingLabel] = [trackingValue];
            }

            try {
                nexusTracking().trackOnNextPageImpression(trackingData);
            } catch (e) {
                // ignore
            }
        });

        registerTrackingEventHandler();
    }

    return {
        sendTrackingInformation: sendTrackingInformation,
        registerTrackingEventHandler: registerTrackingEventHandler,
        init: init
    };
};
